import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { SELECT_MOBILE_USER_DETAILS } from "src/api-setup/api-endpoints";

// every profile (provider and position) of the logged-in user, in the SP's order; [] when there are none
export const getProviderProfiles = async (cookiesData, dispatch) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_sort_number: 1,
      in_sort_order: "ASC",
    };

    const response = await POSTAPI(false, SELECT_MOBILE_USER_DETAILS, null, apiHeaders, requestBody, dispatch);
    const rowResult = response?.data?.row_result;

    if (response?.data?.out_parameters?.out_ret_code === 0 && Array.isArray(rowResult)) {
      return rowResult;
    }
    return [];
  } catch (error) {
    console.error("Error fetching provider profiles:", error);
    return [];
  }
};
